// @flow
import React from 'react';
import { useSequentialConfirmation } from '@src/custom-hooks/useSequentialConfirmation';

import { StyledButton } from '../../../common-utils/styledComponents';

export const SaveFormButton = ({
  disabled,
  onClick,
  shouldShowConfirmation = false,
  confirmationConfigs = [],
}) => {
  const { handleClick, confirmModal } = useSequentialConfirmation({
    onClick,
    shouldShowConfirmation,
    confirmationConfigs,
  });

  return (
    <>
      <StyledButton
        circular={true}
        data-testid="save-form-button"
        disabled={disabled}
        icon="check"
        onClick={handleClick}
        primary={true}
        size="small"
      />
      {confirmModal}
    </>
  );
};
